// react
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
// third-party
import { Helmet } from 'react-helmet-async';
import userApi from '../../server/real/endpoints/users';

export default function AccountPageResetPassword() {
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');

    function onPasswordChange(e) {
        setPassword(e.target.value);
    }
    function onValidationPasswordChange(e) {
        setPassword2(e.target.value);
    }

    function validationMessages() {
        const errorMessageList = [];
        if (password.length > 0) {
            if (password.search(/[a-z]/) < 0) {
                errorMessageList.push(<span><FormattedMessage id="account_passerrorletter" defaultMessage="Your password must contain at least one letter." /></span>);
            }
            if (password.search(/[A-Z]/) < 0) {
                errorMessageList.push(<span><FormattedMessage id="account_passerrorcapitalletter" defaultMessage="Your password must contain at least one capital letter." /></span>);
            }
            if (password.search(/[.^#!'<>"&/%*+?^${}()|[\]\\]/g, '\\$&') < 0) {
                errorMessageList.push(<span><FormattedMessage id="account_passerrorsymbol" defaultMessage="Your password must contain at least one special character." /></span>);
            }
            if (password.search(/[0-9]/) < 0) {
                errorMessageList.push(<span><FormattedMessage id="account_passerrordigit" defaultMessage="Your password must contain at least one digit." /></span>);
            }
            if (password.length < 8) {
                errorMessageList.push(<span><FormattedMessage id="account_passerrorminchar" defaultMessage="Your password must be at least 8 characters." /></span>);
            }
            if (password.length > 16) {
                errorMessageList.push(<span><FormattedMessage id="account_passerrormaxchar" defaultMessage="Your password must be 16 or lower characters" /></span>);
            }
        }

        // setGreen('form-control is-invalid');
        return errorMessageList;
    }

    function password2Valid() {
        if (password === password2 && password.length > 0) {
            return true;
        }
        return false;
    }

    function confirmValidationComponent() {
        const valid = password2Valid();
        if (valid) {
            return (<span />);
        }
        return (<span><FormattedMessage id="account_passerrornotmatch" defaultMessage="Paswords does not match" /></span>);
    }

    function formClassName() {
        const messages = validationMessages();
        if (password.length > 0) {
            if (messages.length > 0) {
                return 'form-control is-invalid';
            }

            return 'form-control is-valid';
        }
        return 'form-control';
    }

    function validationFormClassName() {
        const isPassword2Valid = password2Valid();
        if (password2.length > 0) {
            if (!isPassword2Valid) {
                return 'form-control is-invalid';
            }
            return 'form-control is-valid';
        }
        return 'form-control';
    }

    function passwordValid() {
        if (password === password2 && validationFormClassName() === formClassName() && password.length > 7) {
            return false;
        }
        return true;
    }

    const { search } = useLocation();
    const token = new URLSearchParams(search).get('token');
    const email = new URLSearchParams(search).get('email');

    const resetPassword = () => {
        userApi.resetPassword(email, password, token).then((response) => {
            if (response.data.success) { window.location = '/'; }
        });
    };

    return (
        <div className="card">
            <Helmet>
                <title>Reset Password</title>
            </Helmet>

            <div className="card-header">
                <h5><FormattedMessage id="account_passreset" defaultMessage="Reset Password" /></h5>
            </div>
            <div className="card-divider" />
            <div className="card-body">
                <div className="row no-gutters">
                    <div className="col-12 col-lg-7 col-xl-6">
                        <div className="form-group">
                            <label htmlFor="password-new">
                                <FormattedMessage id="account_passnew" defaultMessage="New Password" />
                            </label>

                            <input
                                type="password"
                                className={formClassName()}
                                id="password-new"
                                placeholder="New Password"
                                onChange={onPasswordChange}
                            />
                            {validationMessages().map((message) => (<div className="invalid-feedback">{message}</div>))}

                            <div className="valid-feedback"><FormattedMessage id="account_passerrorgood" defaultMessage="Password is good." /></div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="password-confirm">
                                <FormattedMessage id="account_passreenter" defaultMessage="Reenter New Password" />
                            </label>
                            <input
                                type="password"
                                className={validationFormClassName()}
                                id="password-confirm"
                                placeholder="Reenter New Password"
                                onChange={onValidationPasswordChange}
                            />

                            <div className="invalid-feedback">{confirmValidationComponent()}</div>

                            <div className="valid-feedback"><FormattedMessage id="account_passmatchsuccess" defaultMessage="Passwords are match!" /></div>
                        </div>

                        <div className="form-group mt-5 mb-0">
                            <button type="button" disabled={passwordValid()} className="btn btn-primary" onClick={resetPassword}>
                                <FormattedMessage id="account_passresetbutton" defaultMessage="Reset my password" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
